Vue.component('loading', {
    template: `
        <div id="loading" :class="{active: loading}">
            <div class="side" :class="{showAll: !all}"></div>
            <div class="main">
                <i class="fas fa-spinner fa-spin"></i>
            </div>

        </div>
    `,
    data: function() {
        return {
            loading: true,
            all: true
        };
    },

    mounted() {

        EventBus.$on('HIDE_LOADING', () => {
            this.loading = false;
        });

        EventBus.$on('SHOW_LOADING', (all) => {
            this.loading = true;
            if (!this.$fullFrame) {
                this.all = !all;
            }
        });

    },

    methods: {

    }
});
